// RxJS
import { debounceTime } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectAffiliationTypesInStore,
  selectAffiliationTypesPageLoading,
  selectAffiliationTypesShowInitWaitingMessage,
} from '../_selectors/affiliation-type.selectors';
import { AffiliationType } from '../_models/affiliation-type.model';

export class AffiliationTypesDataSource extends BaseDataSource {
  private allItems: AffiliationType[];

  constructor(private store: Store<AppState>, private paginator) {
    super();

    this.store
      .pipe(select(selectAffiliationTypesInStore), debounceTime(600))
      .subscribe((response: QueryResultsModel) => {
        this.allItems = response.items;
        this.entitySubject.next(response.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(response.totalCount);
      });

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectAffiliationTypesShowInitWaitingMessage),
    );

    this.loading$ = this.store.pipe(select(selectAffiliationTypesPageLoading));
  }

  getAllItems() {
    return this.allItems;
  }

  setAllItems(items) {
    this.allItems = items;
  }
}
